import React, { FC, Fragment } from 'react';
import times from 'lodash/times';
import { Table } from './CompareTable.styles';
import { TableRowLoading } from '../TableRow/TableRow.loading';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { HeaderRow } from '../HeaderRow/HeaderRow';

interface Props {
  planNames: string[];
}

export const CompareTableLoading: FC<Props> = ({ planNames }) => {
  return (
    <Table>
      <tbody>
        <tr>
          <Box as="td" p="24" />

          {planNames.map(planName => (
            <Box key={planName} as="td" p="24">
              <Text fontSize="h5" fontWeight={600} textAlign="center" isOverflowWrap>
                {planName}
              </Text>
            </Box>
          ))}
        </tr>

        {times(4).map(key => (
          <Fragment key={key}>
            <HeaderRow isLoading label="" planIds={planNames} />

            {times(4).map(_key => (
              <TableRowLoading key={_key} planNames={planNames} />
            ))}
          </Fragment>
        ))}
      </tbody>
    </Table>
  );
};
